import React from "react";

const SectionTitle = ({ title }) => {
    return (
        <div className="flex items-center gap-4">
            <div className="bg-gradient-to-r from-primary to-secondary h-[2px] w-8"/>
            <h1 className="text-4xl	leading-10">{title}</h1>
            <div className="w-2 h-2 border border-solid	border-white rounded-full bg-white"></div>
        </div>
    );
}

export default SectionTitle;